<template>
  <div class="login-wrapper">
    <div class="login-main">
      <div class="title">
        <img src="@/assets/logo.png" alt class="logo" />
        <h2 class="login-title">农电云库管理系统</h2>
      </div>
      <el-input
        type="text"
        prefix-icon="el-icon-user-solid"
        v-model.trim="username"
        placeholder="用户名"
        clearable
        autofocus
      ></el-input>
      <el-input
        type="text"
        prefix-icon="el-icon-lock"
        show-password
        v-model.trim="password"
        @keyup.native.enter="login"
        placeholder="密码"
      ></el-input>
      <el-button :loading="loading" type="primary" @click="login" class="login-btn">{{_loginText}}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      loading: false,
      loginText: "登录"
    };
  },
  //监听属性
  computed: {
    _loginText: function() {
      return this.loading ? "登录中。。。" : "登录";
    }
  },
  created() {
    var _this = this;
    document.onkeydown = function(e) {
      var key = window.event.keyCode;
      if (key == 13) {
        if (_this.$route.path == "/login") {
          _this.login();
        }
      }
    };
  },
  //方法列表
  methods: {
    // 登录方法
    login() {
      if (!this.username || !this.password)
        return this.$toast("warning", "请输入用户名和密码");
      this.loading = true; //加载中
      this.$http({
        url: this.$api.logining,
        method: "POST",
        data: { username: this.username, password: this.password }
      }).then(res => {
        this.loading = false;
        if (res.data.code == 200) {
          sessionStorage.setItem("token", res.data.data.sysUser.accessToken);
          sessionStorage.setItem(
            "userinfo",
            JSON.stringify(res.data.data.sysUser)
          );
          this.$toast("success", res.data.msg);
          // this.$router.push("/FileMange"); //路由进入到文章管理
          this.$router.push("/dashboard"); //4/7改为首页 


          // this.$store.dispatch("menu/FileMange"); //4/7 新加的动态路由
          
          sessionStorage.setItem("$url",this.$URL); //接口地址
          this.$store.dispatch("app/changeActiveIndex", "1-1");
          sessionStorage.setItem("activeIndex", "1-1");
        } else {
          this.$toast("warning", res.data.msg);
        }
      });
    },
    setUser(user) {
      //dispatch
      this.$store.dispatch("user/login", user);
    }
  }
};
</script>

<style lang="scss" >
.login-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: url("../../assets/login.png") no-repeat;
  background-size: cover;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  .login-main {
    // position: absolute;
    width: 4.5rem;
    // right: 0;
    // left: 0;
    // top: 43vh;

    .logo {
      width: 0.8rem;
      height: 0.8rem;
      margin-bottom: 0.1rem;
    }

    .title {
      text-align: center;

      .login-title {
        font-size: 0.3rem;
        color: #292929;
      }
    }

    .el-input {
      margin-top: 0.3rem;
      font-size: 0.14rem;
    }

    .el-input__inner {
      height: 0.5rem;
      line-height: 0.5rem;
      padding: 0 0.15rem;
    }

    .el-input--prefix .el-input__inner {
      padding-left: 0.3rem;
    }

    .el-input__prefix {
      left: 0.05rem;
    }

    .el-input__icon {
      width: 0.25rem;
      line-height: 0.5rem;
    }

    .login-btn {
      width: 100%;
      margin-top: 0.5rem;
      height: 0.5rem;
      padding: 0.12rem 0.2rem;
      // background-color: @baseFocusColor;
      border: none;
      border-radius: 0.06rem;
      color: #fff;
      font-size: 0.18rem;
      letter-spacing: 0.05rem;
      transition: all 300ms;

      // &:active {
      //   box-shadow: 1px 1px 0 1px @baseFocusColor;
      //   transform: translate3d(0, 1px, 0);
      // }
    }
  }
}
</style>
